<template>
  <section id="contact-me" class="contact-me main-layout full">
    <h1>Contact Me</h1>
    <section>
      <a class="tel" href="tel:054-5586006"
        ><img
          src="https://res.cloudinary.com/disku3v4j/image/upload/v1640549113/daniiel/icons8-phone-30_ylnw49.png"
        />
        054-5586006</a
      >
      <a class="email" href="mailto:daniieldvir2406@gmail.com">
        <img
          src="https://res.cloudinary.com/disku3v4j/image/upload/v1640549113/daniiel/icons8-mail-24_rare7o.png"
        />Click to email me</a
      >
    </section>
    <section class="contact-btn">
      <button>
        <a href="https://www.linkedin.com/in/daniiel-dvir-06154769/">
          <img
            src="https://res.cloudinary.com/disku3v4j/image/upload/v1639947219/daniiel/linkedin_odd9sz.png"
        /></a>
      </button>
      <button>
        <a href="https://www.facebook.com/daniiel.dvir">
          <img
            src="https://res.cloudinary.com/disku3v4j/image/upload/v1639947219/daniiel/facebook_fpfrs7.png"
          />
        </a>
      </button>
      <button>
        <a href="https://github.com/daniieldvir">
          <img
            src="https://res.cloudinary.com/disku3v4j/image/upload/v1639947219/daniiel/github-sign_p5pq7p.png"
        /></a>
      </button>
    </section>
  </section>
</template>

<script>
export default {};
</script>

<style></style>
